module.exports = __webpack_public_path__ + "img/RouletteRectangle1.14e665d3.png";